import { render } from "./CreateIncomePage.vue?vue&type=template&id=6201a346&ts=true"
import script from "./CreateIncomePage.vue?vue&type=script&lang=ts"
export * from "./CreateIncomePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__